
const ApproachSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            Our Approach
          </h2>
          
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
            <p>
              At HP Inc Consulting Services, we work closely with you to identify your employees' specific hazards and develop a comprehensive training plan to address those risks. Our process begins with assessing your company's needs and creating a training matrix that outlines the required training for each job description and role within your organization.
            </p>
            <p>
              Every company is unique, so we offer various training options to suit your needs. Whether you require ad hoc training for a specific topic or ongoing support as a partner client, we have the expertise and flexibility to meet your requirements.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;
